<div class="text-center">
    <button class="btn rounded-pill bg-secondary-color py-2 px-5 text-white" (click)="orderNow()"> order now</button>

</div>